(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets/assets/javascripts/next/components/hero.js') >= 0) return;  svs.modules.push('/modules/tickets/assets/javascripts/next/components/hero.js');
'use strict';

const getImageAspectRatio = function () {
  let image = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const width = Number(image === null || image === void 0 ? void 0 : image.width);
  const height = Number(image === null || image === void 0 ? void 0 : image.height);
  if (Number.isFinite(width) && Number.isFinite(height) && height > 0) {
    return width / height;
  }
  return 1;
};
const Hero = _ref => {
  var _heroTicket$skins;
  let heroTicket = _ref.heroTicket,
    onSelectProduct = _ref.onSelectProduct;
  if (!heroTicket) {
    return null;
  }
  const ImageMemo = svs.tickets.next.components.ImageMemo;
  const TicketWithPodiumShadow = svs.tickets.next.components.TicketWithPodiumShadow;
  const AnimatedBackgrounds = svs.tickets.next.components.animatedBackground.AnimatedBackgrounds;
  const imageData = (_heroTicket$skins = heroTicket.skins) === null || _heroTicket$skins === void 0 || (_heroTicket$skins = _heroTicket$skins[0]) === null || _heroTicket$skins === void 0 ? void 0 : _heroTicket$skins.image;
  const imageAspectRatio = getImageAspectRatio(imageData);
  const ticketLabel = heroTicket.name || heroTicket.type;
  const ariaLabel = heroTicket.price ? "V\xE4lj ".concat(ticketLabel, ", ").concat(heroTicket.price, " kronor") : "V\xE4lj ".concat(ticketLabel);
  const handleSelectProduct = event => {
    event.preventDefault();
    onSelectProduct(heroTicket);
  };
  return React.createElement("div", {
    className: "tickets-next-hero u-position-relative w100"
  }, React.createElement(AnimatedBackgrounds, {
    ticketInfo: heroTicket
  }), React.createElement("a", {
    "aria-label": ariaLabel
    ,
    className: "qa-tickets-next-hero-ticket tickets-next-hero-ticket-link padding-0 u-position-absolute u-left-50 u-flex u-flex-align-items-end u-flex-justify-content-center pointer u-text-decoration-none",
    href: "#",
    onClick: handleSelectProduct
  }, React.createElement(ImageMemo, {
    cssSelectors: "tickets-next-hero-image",
    fitWrapper: false,
    image: imageData
  })), React.createElement("div", {
    className: "tickets-next-hero-podium u-position-absolute u-bottom-0"
  }, React.createElement(TicketWithPodiumShadow, {
    aspectRatio: imageAspectRatio,
    opacity: 0.7,
    translateY: "35%"
  })), heroTicket.price && React.createElement("div", {
    "aria-hidden": "true",
    className: "tickets-next-hero-price-tag u-position-absolute"
  }, heroTicket.price, " kr"));
};
setGlobal('svs.tickets.next.components.Hero', Hero);

 })(window);